import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import FilmData from "./Components/Main/FilmData.jsx";
import AppWrapper from "./Components/AppWrapper";
import Auth from "./Components/Auth/Auth";
import GetEPG from "./Components/Main/GetEPG";
import { Box } from "@mui/material";

function App() {
  const isAuthenticated = () => {
    return (
      localStorage.getItem("cinema.Login") &&
      localStorage.getItem("cinema.Token")
    );
  };
  return (
    <Router>
      <Box sx={{ height: "100vh" }}>
        <Routes>
          {/* <Route path="/" element={<AppWrapper />} /> */}
          <Route
            path="/"
            element={
              isAuthenticated() ? <AppWrapper /> : <Navigate to="/auth" />
            }
          />
          <Route
            path="/auth"
            element={
              <Auth onAuthSuccess={() => (window.location.href = "/")} />
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/filmdata" element={<FilmData />} />
          <Route path="/met" element={<GetEPG />} />
        </Routes>
      </Box>
    </Router>
  );
}

export default App;
